import styled from "styled-components";

export const BtnWrapSignUp = styled.div`
  display: flex;
  flex-direction: row;
  button {
    margin: 0px 10px;
  }
`;
